import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PAGELENGTH } from 'components/common/ListLayout';
import Api from "services/api"
import { logout } from './userSlice';


export const initialState = {
  dashboard: {
    analytics: [],
    appointments: [],
  },
  error: null,
  loader: false,
  featured: {},
  current_page: 1,
  per_page: PAGELENGTH
}

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: initialState,
  reducers: {
    setDashboardAnalytic: (state, { payload }) => {
      state.dashboard = payload?.data ?? payload;
    },
    setDashboardAnalytics: (state, { payload }) => {
      state.dashboard.analytics = payload;
    },
    setDashboardAppointments: (state, { payload }) => {
        state.dashboard.appointments = payload?.data;
        state.total = payload?.total;
        state.is_more = payload?.is_more;
        state.last_page = payload?.last_page;
        state.current_page = payload?.current_page;
        state.per_page = payload?.per_page
    },
    removerVendorReports: (state, { payload }) => {
      state.error = payload
    },
    clearAllDashboard: (state, { payload }) => {
        state.loader = payload
    },
    setError: (state, { payload }) => {
        state.error = payload
    },
    setLoader: (state, { payload }) => {
        state.loader = payload
    },
  }
})


export const fetchDashboardAnalytics = (params, disableLoader) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true))
  try {
      
      const result = await Api.fetchClientDashboardAnalytics(params)
      if (result.status >= 200 && result.status < 300) {
          dispatch(setDashboardAnalytics(result.data.data));
    }
    else if (result?.status == 422) {
        dispatch(setError(result.data))
    }
    else if(result?.status == 401){
      dispatch(setError("Unauthorized"))
      dispatch(logout())
    }
  } catch (error) {
    console.log("error", error)
    
  }
  !disableLoader && dispatch(setLoader(false))
}



export const fetchDashboardAppointments = (page, params, disableLoader) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true))
  try {

      const result = await Api.fetchClientDashboardAppointment(page, params)
    if (result.status >= 200 && result.status < 300) {
      if (page > 1) {
        dispatch(setDashboardAppointments(result.data.data));
      } else {
        dispatch(setDashboardAppointments(result.data.data));
      }
    }
    else if (result?.status == 422) {
      dispatch(setError(result.data))
    }
    else if(result?.status == 401){
      dispatch(setError("Unauthorized"))
      dispatch(logout())
    }
  } catch (error) {
    console.log("error", error)

  }
  !disableLoader &&  dispatch(setLoader(false))
}

// Counts what a reminder run WOULD email, without sending anything or consuming the
// 24-hour throttle — so the admin sees the blast radius before confirming.
export const previewDashboardReminder = (callback) => async (dispatch) => {
  dispatch(setLoader(true));
  try {
    const result = await Api.sendDashboardReminder(null, { preview: 1 });
    if (result?.status >= 200 && result?.status < 300) {
      if (callback) callback(true, result.data?.data || {});
    } else {
      if (callback) callback(false, result?.data?.message || "Could not check how many reminders would be sent.");
    }
  } catch (error) {
    console.log("Reminder preview error:", error);
    if (callback) callback(false, error?.message || "Server error");
  }
  dispatch(setLoader(false));
};

export const sendDashboardReminder = (callback) => async (dispatch) => {
  dispatch(setLoader(true));
  try {
    const result = await Api.sendDashboardReminder();
     if (result.status >= 200 && result.status < 300) {
      const message = result.data?.message || "Reminder emails sent successfully!";
      if (callback) callback(true, message);
    }
    else if (result?.status === 422) {
      dispatch(setError(result.data));
    } else if (result?.status === 401) {
      dispatch(setError("Unauthorized"));
      dispatch(logout());
     } else {
      const message = result.data?.message
      if (callback) callback(false, message);
    }
  } catch (error) {
    console.log("Reminder Error:", error);
    if (callback) callback(false, error?.message || "Server error");
  }
  dispatch(setLoader(false));
};



export const { setDashboardAnalytics, clearAllDashboard, setLoader, setError ,setDashboardAppointments} = dashboardSlice.actions

export default dashboardSlice.reducer
export const DashboardSelector = state => state.dashboard



